import { useCallback, useEffect, useRef, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import InvestmentHub from "@/pages/InvestmentHub";
import LeadsDesk from "@/pages/LeadsDesk";
import ParcelDetail from "@/pages/ParcelDetail";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("dn-theme");
    if (saved === "light" || saved === "dark") return saved;
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  });
  const lenisRef = useRef(null);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("dn-theme", theme);
  }, [theme]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((selector) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(selector, { offset: -64, duration: 1.4 });
    }
  }, []);

  const toggleTheme = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    []
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Landing
              theme={theme}
              onToggleTheme={toggleTheme}
              onNavigate={scrollTo}
            />
          }
        />
        <Route
          path="/desk"
          element={<LeadsDesk theme={theme} onToggleTheme={toggleTheme} />}
        />
        <Route
          path="/parcel/:id"
          element={<ParcelDetail theme={theme} onToggleTheme={toggleTheme} />}
        />
        <Route
          path="/investments"
          element={<InvestmentHub theme={theme} onToggleTheme={toggleTheme} />}
        />
      </Routes>
      <Toaster
        theme={theme}
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            fontFamily: '"Space Mono", monospace',
            fontSize: 12,
          },
        }}
      />
    </BrowserRouter>
  );
}
